var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"history"}},[_c('h3',{staticClass:"headline"},[_vm._v("History")]),_c('p',[_vm._v(_vm._s(_vm.History)+" "),_c('span',{on:{"click":_vm.Change}},[_vm._v(_vm._s(_vm.Text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }